import { ShareFill } from "react-bootstrap-icons";

export function SharingStatus(props) {
	let {
		profile,
		ownerUid,
		childAutoAccess
	} = props;

	if(ownerUid == null) {
		return null; // probably unsaved
	}
	
	if(childAutoAccess) {
		if(profile.isUidInAccountTree(parseInt(ownerUid))) {
			return null;
		}
	} else {
		if(profile.isUidInSelfOrSubaccount(parseInt(ownerUid))) {
			// Access through account tree
			return null;
		}	
	}

	return <ShareFill />
}